module.exports = __webpack_public_path__ + "img/r-michelle-tsang-500721-unsplash-min-600x395.5fb9508c.jpg";